import { render } from "./CascaderPanel.vue?vue&type=template&id=d8e47c64"
import script from "./CascaderPanel.vue?vue&type=script&lang=ts"
export * from "./CascaderPanel.vue?vue&type=script&lang=ts"
script.render = render

export default script